module.exports = __webpack_public_path__ + "202669:9205d1a92be8207f1496/img/Till-This-Day-Tile_no-spot.44aac0a.png";